(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ehs-brief-description"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-ehs-jump-to-description]');

    if (!trigger) {
      return;
    }

    var descriptionBlock = document.querySelector('.product-info__block-item[data-block-type="description"]');

    if (!descriptionBlock) {
      return;
    }

    var details = descriptionBlock.querySelector('details');

    if (details) {
      details.open = true;
    }

    descriptionBlock.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  } catch(e) { console.error(e); }
})();

})();
